import classNames from "classnames";
import React, { useEffect } from "react";
import { heapTrack } from "lib/analytics";
import { QUESTION_TYPE } from "lib/constants";

import LongAnswer from "./Question/LongAnswer";
import SelectOne from "./Question/SelectOne";
import SelectMany from "./Question/SelectMany";
import ShortAnswer from "./Question/ShortAnswer";
import SelectENPS from "./Question/SelectENPS";
import { QuestionComponentType, QuestionProps } from "./Question/types";

const QUESTION_COMPONENT_MAP: { [key: string]: QuestionComponentType } = {
    [QUESTION_TYPE.SELECT_ONE]: SelectOne,
    [QUESTION_TYPE.CHOOSE_ONE]: SelectOne,
    [QUESTION_TYPE.RATE_ONE]: SelectOne,
    [QUESTION_TYPE.RATE_SATISFACTION]: SelectOne,
    [QUESTION_TYPE.ENPS]: SelectENPS,
    [QUESTION_TYPE.FOLLOW_UP]: SelectOne,
    [QUESTION_TYPE.CHOOSE_MANY]: SelectMany,
    // short answer isn't used, but still technically exists as an option (for now)
    [QUESTION_TYPE.SHORT_ANSWER]: ShortAnswer as unknown as QuestionComponentType,
    [QUESTION_TYPE.LONG_ANSWER]: LongAnswer,
    [QUESTION_TYPE.RATE_ONE_TEN_SCALE]: SelectENPS,
};

const Question = ({ className, type, extraData, ...props }: QuestionProps) => {
    const QuestionComponent = QUESTION_COMPONENT_MAP[type];
    useEffect(
        () =>
            heapTrack("Survey Question Shown", {
                checkin_id: extraData?.checkin_id,
                checkin_hire_id: extraData?.checkin_hire_id,
                question_id: props.id,
            }),
        [props.id],
    );
    return (
        <div className={classNames("questions__question", className)}>
            <QuestionComponent type={type} extraData={extraData} {...props} />
        </div>
    );
};

export default Question;
